import { render } from "./ClientHistoryDialogDate.vue?vue&type=template&id=639a40bf&scoped=true"
import script from "./ClientHistoryDialogDate.vue?vue&type=script&lang=ts"
export * from "./ClientHistoryDialogDate.vue?vue&type=script&lang=ts"

import "./ClientHistoryDialogDate.vue?vue&type=style&index=0&id=639a40bf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-639a40bf"

export default script